import { defineComponent as _defineComponent } from 'vue'
import XSolidIcon from '@/assets/img/XSolidIcon.svg'
import { Notification } from '~/store/notificationStore'


export default /*#__PURE__*/_defineComponent({
  __name: 'ModalToast',
  props: {
    title: null,
    message: null,
    colorClass: null,
    icon: null,
    button: null
  },
  emits: ["close"],
  setup(__props: any) {

const props = __props as {
  title: string
  message: string
  colorClass: string
  icon: any
  button: Notification['button']
};





return { __sfc: true,props, XSolidIcon }
}

})